import { Component, Element, State, h } from '@stencil/core';
import Personnummer from 'personnummer';
import state from '../../store';
import apiSearch from '../../utils/creditSafe';
import { scrollToTop } from '../../utils/scroll';

@Component({
  tag: 'hemfixarna-getuser',
  shadow: false,
})
export class HemfixarnaGetuser {
  @State() email: string = '';
  @State() emailError: string | null = null;
  @State() phone: string = '';
  @State() phoneError: string | null = null;
  @State() ssn: string = '';
  @State() ssnError: string | null = null;
  @Element() private el: HTMLElement;

  componentWillLoad() {
    if (state.user) {
      this.email = state.user.email;
      this.phone = state.user.phone;
      this.ssn = state.user.ssn;
    }
  }

  handleChangeEmail = (e: Event) => {
    this.emailError = null;
    this.email = (e.target as HTMLInputElement).value;
  };

  handleChangePhone = (e: Event) => {
    this.phoneError = null;
    this.phone = (e.target as HTMLInputElement).value;
  };

  handleChangessn = (e: Event) => {
    this.ssnError = null;
    this.ssn = (e.target as HTMLInputElement).value;
  };

  handleSubmit = async (e: Event) => {
    e.preventDefault();
    const emailRegex = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    const validEmail = emailRegex.test(this.email);
    if (!validEmail) {
      this.emailError = 'Ange en giltig e-postadress';
    }
    const validPhone = /^[\d\s()+-]{6,}$/.test(this.phone);
    if (!validPhone) {
      this.phoneError = 'Ange ett giltigt telefonnummer';
    }
    const validssn = Personnummer.valid(this.ssn);
    if (!validssn) {
      this.ssnError = 'Ange ett giltigt personnummer';
    } else if (validssn) {
      const pn = Personnummer.parse(this.ssn).format(true);
      this.ssn = [pn.slice(0, 8), '-', pn.slice(8)].join('');
    }
    if (validEmail && validPhone && validssn) {
      try {
        const creditSafeData = await apiSearch(this.ssn);
        if (creditSafeData) {
          state.creditSafeUser = creditSafeData;
          state.checkoutStep = 2;
          state.user = {
            ...creditSafeData,
            email: this.email,
            phone: this.phone,
            ssn: this.ssn,
          };
        } else {
          this.ssnError = 'Vi kunde tyvärr inte hitta en address med ditt angivna personnummer';
        }
      } catch (e) {
        this.ssnError = 'Vi kunde tyvärr inte hitta en address med ditt angivna personnummer';
        console.log(e);
      } finally {
        const el = this.el.closest('.hemfixarna_content');
        scrollToTop(el);
      }
    }
  };

  render = () => {
    return (
      <form class="mb-2" onSubmit={e => this.handleSubmit(e)}>
        <div>
          <input class={`${this.email.length ? 'input_active' : ''}`} onChange={e => this.handleChangeEmail(e)} type="email" name="email" value={this.email} />
          <label htmlFor="email">E-post </label>
        </div>
        {this.emailError && <span>{this.emailError}</span>}
        <div>
          <input class={`${this.phone.length ? 'input_active' : ''}`} onChange={e => this.handleChangePhone(e)} type="tel" name="phone" value={this.phone} />
          <label htmlFor="phone">Mobiltelefon </label>
        </div>
        {this.phoneError && <span>{this.phoneError}</span>}
        <div>
          <input class={`${this.ssn.length ? 'input_active' : ''}`} onChange={e => this.handleChangessn(e)} type="tel" name="ssn" value={this.ssn} />
          <label htmlFor="phone">Personnummer*</label>
        </div>
        {this.ssnError && <span>{this.ssnError}</span>}
        <input type="submit" value="Fortsätt*" />
        <p>*Vi hämtar din adress</p>
      </form>
    );
  };
}
